module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1ded23dadd94aadcfcd0184a85af76d5.1ded23da.png";